import uuidv4 from "../../utils/uuidv4";

const THEME_PATH = "bussoft-theme";
const COMPUTER_INDENTITY_PATH = "esir--bus-uid-computer";
const SESSION_ID_PATH = "bussoft-session_id";
const TRAINING_MODE_PATH = "bussoft-training";
const OPERATOR_PATH = "bussoft-operator";
const USER_PATH = "bussoft-userInfo";
const SELECTED_LOCATION_PATH = "bussoft-selected-location";
const APP_VERSION_PATH = "bussoft-app-version";
const SILENT_PRINT_PATH = "bussoft-silent-print";
const SESSION_LANGUAGE = "bussoft-language";
const INIT_LOGGED_LANGUAGE = "bussoft-init-logged-user";
const PRINTER_SIZE_PATH = "bussoft-printer-size-path";
const PUBLISHED_LINES_PATH = "bussoft-published_lines-path";
const A4_CALIBRATION_PATH = "bussoft-a4-calibration";

// ----------- INTI LOGIN ------------------
export function getIniLoggedUser(){
  return localStorage.getItem(INIT_LOGGED_LANGUAGE)
      ? JSON.parse(localStorage.getItem(INIT_LOGGED_LANGUAGE))
      : undefined;
}

export function setIniLoggedUser(user){
  localStorage.setItem(INIT_LOGGED_LANGUAGE, JSON.stringify(user));
}

// ----------- PUBLISHED LINES ----------------

export function getPublishedLines(){
  const fromDb = localStorage.getItem(PUBLISHED_LINES_PATH)
  return fromDb ? JSON.parse(fromDb) : {};
}

export function setPublishedLines(data){
  localStorage.setItem(PUBLISHED_LINES_PATH, JSON.stringify(data))
}

// ----------- KALIBRACIJA A4 ŠTAMPE ----------------

const A4_CALIBRATION_DEFAULT = {scale: 1, topMm: 0, marks: false};

export function getA4Calibration() {
  try {
    const stored = JSON.parse(localStorage.getItem(A4_CALIBRATION_PATH));
    const scale = Number(stored?.scale);
    const topMm = Number(stored?.topMm);
    return {
      scale: Number.isFinite(scale) && scale > 0.5 && scale < 1.5 ? scale : A4_CALIBRATION_DEFAULT.scale,
      topMm: Number.isFinite(topMm) && Math.abs(topMm) < 30 ? topMm : A4_CALIBRATION_DEFAULT.topMm,
      marks: stored?.marks === true
    };
  } catch (e) {
    return {...A4_CALIBRATION_DEFAULT};
  }
}

export function setA4Calibration(calibration) {
  localStorage.setItem(A4_CALIBRATION_PATH, JSON.stringify({
    ...A4_CALIBRATION_DEFAULT,
    ...calibration
  }));
}

// ----------- SILENT PRINT ----------------

export function getSilentPrint(){
  return localStorage.getItem(SILENT_PRINT_PATH) === "true"
}

export function setSilentPrint(silent){
  localStorage.setItem(SILENT_PRINT_PATH, silent);
}

export function getPrinterSize(){
  let size =  localStorage.getItem(PRINTER_SIZE_PATH)
  if(size){
    size = size.replaceAll("\"", "")
  }else{
    return null;
  }
  return Number(size)
}

export function setPrinterSize(size){
  localStorage.setItem(PRINTER_SIZE_PATH, JSON.stringify(size));
}

// ----------- LOKACIJA -------------------
export function setSessionSelectedLocation(location) {
  localStorage.setItem(SELECTED_LOCATION_PATH, JSON.stringify(location));
}

export function getSessionSelectedLocation() {
  return localStorage.getItem(SELECTED_LOCATION_PATH)
    ? JSON.parse(localStorage.getItem(SELECTED_LOCATION_PATH))
    : undefined;
}

// ----------- USER INFO -------------------

// export function setSessionUser(){
//   localStorage.setItem(USER_PATH, JSON.stringify(location));
// }

export function getSessionUser() {
  return localStorage.getItem(USER_PATH)
      ? JSON.parse(localStorage.getItem(USER_PATH))
      : undefined;
}

// ----------- OPERATER -------------------

export function setSessionOperator(operator) {
  localStorage.setItem(OPERATOR_PATH, JSON.stringify(operator));
}

export function removeSessionOperator() {
  localStorage.removeItem(OPERATOR_PATH);
}

export function getSessionOperator() {
  return localStorage.getItem(OPERATOR_PATH)
    ? JSON.parse(localStorage.getItem(OPERATOR_PATH))
    : undefined;
}

// ----------- VERZIJA -------------------
export function getSessionAppVersion() {
  return localStorage.getItem(APP_VERSION_PATH)
    ? parseFloat(localStorage.getItem(APP_VERSION_PATH))
    : null;
}

export function setSessionAppVersion(version) {
  localStorage.setItem(APP_VERSION_PATH, version.toString());
}

// ----------- SESIJA -------------------
export function getAndCreateUniqueComputerUid() {
  let id = uuidv4();
  let storedSession = localStorage.getItem(COMPUTER_INDENTITY_PATH);
  if (!storedSession) {
    localStorage.setItem(COMPUTER_INDENTITY_PATH, id);
    return id;
  }
  return storedSession;
}

// ----------- JEZIK -------------------
export const getSessionLanguage = () => {
  return localStorage.getItem(SESSION_LANGUAGE);
};

export const setSessionLanguage = (language) => {
  return localStorage.setItem(SESSION_LANGUAGE, language);
};

export function setSessionId(sessionId) {
  localStorage.setItem(SESSION_ID_PATH, sessionId);
}

export function getSessionId() {
  return localStorage.getItem(SESSION_ID_PATH);
}

export function deleteLocalSessionId() {
  localStorage.removeItem(SESSION_ID_PATH);
}

// ----------- OBUKA MOD -------------------
export function setSessionTrainingMode(active) {
  localStorage.setItem(TRAINING_MODE_PATH, active);
}

export function getSessionTrainingMode() {
  return localStorage.getItem(TRAINING_MODE_PATH) ? (localStorage.getItem(TRAINING_MODE_PATH) === "true") : false;
}

// ----------- TEMA -------------------
export function setSessionTheme(theme) {
  localStorage.setItem(THEME_PATH, theme);
}

export function getSessionTheme() {
  let theme = localStorage.getItem(THEME_PATH);
  return theme ? theme : "light";
}

// ----------- OSTALO -------------------
export function clearSession(isLogout = false) {
  let itemsToRemove;
  if (isLogout) {
    itemsToRemove = [SELECTED_LOCATION_PATH, TRAINING_MODE_PATH, OPERATOR_PATH, INIT_LOGGED_LANGUAGE];
  } else {
    itemsToRemove = [TRAINING_MODE_PATH, OPERATOR_PATH];
  }
  itemsToRemove.forEach(item => localStorage.removeItem(item));
}

export function isTest() {
  if(getSessionSelectedLocation() === null){
    return false
  }
  return getSessionSelectedLocation()?.vsdcURL?.includes("sandbox") || false
}
